import { Validator } from "vee-validate";

export const setCustomValidators = i18n => {
  Validator.extend("protocol", {
    validate: value => {
      if (!value) return true;
      const pattern = new RegExp("^(https?:\\/\\/)");
      return pattern.test(value);
    },
    getMessage: field => {
      return i18n.t("message.common.validation.urlWithProtocol");
    }
  });
  Validator.extend("max-length", {
    validate: (value, [max]) => {
      if (!value) return true;
      return String(value).length <= max;
    },
    params: ["max"],
    getMessage: (field, [maxLength]) => {
      return i18n.t("message.common.validation.maxLength", [maxLength]);
    }
  });
  Validator.extend("min-length", {
    validate: (value, [min]) => {
      if (!value) return true;
      return String(value).length >= min;
    },
    params: ["min"],
    getMessage: (field, [minLength]) => {
      return i18n.t("message.common.validation.minLength", [minLength]);
    }
  });
  Validator.extend("min-words", {
    validate: (value, [min]) => {
      if (!value) return true;
      const wordCount = value
        .trim()
        .split(/\s+/)
        .filter(word => word.length > 0).length;
      return wordCount >= min;
    },
    params: ["min"],
    getMessage: (field, [minWords]) => {
      return i18n.t("message.common.validation.minWords", [minWords]);
    }
  });

  Validator.extend("required", {
    validate: value => {
      return !!value;
    },
    getMessage: field => {
      return i18n.t("message.common.validation.requiredField");
    }
  });
};
